import { useEffect } from 'preact/hooks';
import { defRoute, useRouter } from '@components/router';
import { useCurrentTenant } from '@components/router/session-context';
import { LoadingIndicator } from '@components/loading-indicator';
import { LAST_ROOT_PAGE_URL } from '@components/root-page-layout';
import { communityHomeUrl } from 'client/utils/url';
import { useCurrentUser } from 'client/lib/auth';

function RootRedirectPage() {
  const router = useRouter();
  const user = useCurrentUser();
  const tenant = useCurrentTenant();
  useEffect(() => {
    const url = localStorage.getItem(LAST_ROOT_PAGE_URL);
    let redirectTo = url || '';
    if (!url || url === '/') {
      redirectTo = communityHomeUrl({ isAipMember: user?.isAipMember, user, tenant });
    }
    router.rewrite(redirectTo);
  }, []);

  return <LoadingIndicator />;
}

export const route = defRoute({
  Page: RootRedirectPage,
  authLevel: 'student',
});
